var parent = require('../stable/get-iterator-method');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/get-iterator-method.js
// module id = 4057
// module chunks = 25